import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_25068",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_25068)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.5835 17.2917V3.75H11.3302L11.6635 5.41667H16.2502V12.9167H11.1702L10.8368 11.25H5.8335V17.2917H4.5835ZM12.2085 11.6667H15.0002V6.66667H10.6252L10.2918 5H5.8335V10H11.8752L12.2085 11.6667Z",
			fill: "currentColor"
		})
	})]
});
export default SvgFlag;
